import { render, staticRenderFns } from "./modalNotificar.vue?vue&type=template&id=9506b632&scoped=true&lang=pug&"
import script from "./modalNotificar.vue?vue&type=script&lang=js&"
export * from "./modalNotificar.vue?vue&type=script&lang=js&"
import style0 from "./modalNotificar.vue?vue&type=style&index=0&id=9506b632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9506b632",
  null
  
)

export default component.exports